<template>
  <div style="font-family: poppinsregular">
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="snackbar" right color="#FEBD08">
      <v-layout wrap>
        <v-flex xs11>
          {{ msg }}
        </v-flex>
        <v-flex xs1>
          <v-icon @click="snackbar = !snackbar">mdi-close</v-icon>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap text-left pb-2>
      <v-flex xs12>
        <span style="font-family: poppinssemibold; font-size: 22px" class="clr">
          Stock Management
        </span>
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex xs12>
        <v-tabs
          active-class="myClass"
          v-model="stockStatus"
          show-arrows
          grow
          background-color="#ccccb3"
        >
          <v-tabs-slider color="yellow"></v-tabs-slider>
          <v-tab
            style="color: black; text-decoration: none"
            v-for="item in tabValues"
            :key="item"
          >
            {{ item }}</v-tab
          >
        </v-tabs>
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex xs12>
        <v-simple-table v-if="appLoading == false">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Image</th>
                <th class="text-left">Name</th>
                <th class="text-left">Seller</th>
                <th class="text-left">Category</th>
                <th class="text-left">Sub Category</th>
                <th class="text-left">Stock</th>
                <th class="text-left">Expiry Date</th>
                <th
                  v-if="stockStatus == 1 || stockStatus == 3"
                  class="text-left"
                >
                  Notify
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in productList" :key="i">
                <td>
                  <v-layout justify-center wrap v-if="item.photo">
                    <v-flex align-self-center xs12 pb-2 v-if="item.photo != ''">
                      <v-img
                        contain
                        max-height="80"
                        max-width="100"
                        :src="mediaURL + item.photo"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color=" #FDAC53"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-flex>
                    <v-flex align-self-center xs12 pb-2 v-else>
                      <v-img
                        max-height="80"
                        max-width="100"
                        :src="require('../../assets/images/no-image.png')"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color=" #FDAC53"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-flex>
                  </v-layout>
                </td>
                <td class="text-left">
                  <router-link :to="'/groceryProductInfo?id=' + item._id">
                    {{ item.productId.name }}
                  </router-link>
                </td>
                <td class="text-left">
                  <span v-if="item.sellerId">{{ item.sellerId.shopName }}</span>
                </td>
                <td class="text-left">
                  <span v-if="item.categoryId">{{ item.categoryId.name }}</span>
                </td>
                <td class="text-left">
                  <span v-if="item.subcategoryId">
                    {{ item.subcategoryId.name }}
                  </span>
                </td>
                <td class="text-left">
                  <span v-if="item.stock"></span> <b> {{ item.stock }}</b>
                  <span></span>
                </td>
                <td class="text-left">
                  <span v-if="item.expiryDate">
                    {{ item.expiryDate.slice(0, 10) }}</span
                  >
                  <span v-else> - </span>
                </td>
                 <td class="text-left"   v-if="stockStatus == 1 || stockStatus == 3">
                  <router-link :to="'notifymelist?productId=' +item._id">
                 <v-icon small  color="primary"  >mdi-eye</v-icon>
                  </router-link>

                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex xs12>
        <v-pagination
          :length="totalLength"
          total-visible="7"
          v-model="currentPage"
        >
        </v-pagination>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
   
      currentPage: 1,
      totalLength: null,
      appLoading: false,
      snackbar: false,
      msg: "",
      ss: null,
      stockStatus: null,
      tabValues: [
        "Empty Stock",
        "Out of Stock",
        "Limited Stock",
        "Date Expired",
      ],
      val: null,
      productList: [],
    };
  },
  watch: {
    stockStatus() {
      this.getData();
    },
    currentPage() {
      this.getData();
    },
  },
  methods: {
    getData() {
      this.productList = [] ;
      this.appLoading = true;
      switch (this.stockStatus) {
        case 0:
          this.val = "emptyStock";
          break;
        case 1:
          this.val = "outOffstock";
          break;
        case 2:
          this.val = "limitedStock";
          break;
        case 3:
          this.val = "expExpired";
          break;
        default:
          this.val = "";
      }
      axios({
        url: "/grocery/admin/products/list",
        method: "post",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          status: this.val,
          page: this.currentPage,
          limit: 50,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.productList = response.data.product;
            this.totalLength = Math.ceil(response.data.totalLength / 50);
          } else {
            this.snackbar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.myClass {
  background-color: rgb(231, 173, 27) !important;
}
</style>